
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1s55x_pwi13_99",
  "label": "awsui_label_1s55x_pwi13_103",
  "stud": "awsui_stud_1s55x_pwi13_117"
};
  